import { AuthService } from './authService';
import { ItemUnitsDto } from '../types/itemUnits';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class ItemUnitsService {
  
  async getCurrentItemUnits(): Promise<ItemUnitsDto[]> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/item-units/current`);
    
    if (!response.ok) {
      throw new Error(`Failed to get current item units: ${response.status}`);
    }
    
    return await response.json();
  }

  async getItemUnitsByCompany(companyNo: string): Promise<ItemUnitsDto[]> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/item-units/company/${companyNo}`);
    
    if (!response.ok) {
      throw new Error(`Failed to get item units for company ${companyNo}: ${response.status}`);
    }
    
    return await response.json();
  }

  async getItemUnitsByCompanyAndItem(companyNo: string, itemNo: string): Promise<ItemUnitsDto[]> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/item-units/company/${companyNo}/item/${itemNo}`);
    
    if (!response.ok) {
      throw new Error(`Failed to get item units for company ${companyNo} and item ${itemNo}: ${response.status}`);
    }
    
    return await response.json();
  }

  async getItemUnitsByCompanyAndBarcode(companyNo: string, itemBarCode: string): Promise<ItemUnitsDto> {
    const response = await AuthService.authenticatedGet(`${API_BASE_URL}/item-units/${companyNo}/${itemBarCode}`);
    
    if (!response.ok) {
      throw new Error(`Failed to get item units for company ${companyNo} and barcode ${itemBarCode}: ${response.status}`);
    }
    
    return await response.json();
  }

  async searchByBarcode(barcode: string): Promise<ItemUnitsDto[]> {
    const response = await AuthService.authenticatedGet(
      `${API_BASE_URL}/item-units/barcode/current?barcode=${encodeURIComponent(barcode)}`
    );
    
    if (!response.ok) {
      throw new Error(`Failed to search item units by barcode: ${response.status}`);
    }
    
    return await response.json();
  }

  async searchByBarcodeInCompany(companyNo: string, barcode: string): Promise<ItemUnitsDto[]> {
    const response = await AuthService.authenticatedGet(
      `${API_BASE_URL}/item-units/barcode/${companyNo}?barcode=${encodeURIComponent(barcode)}`
    );
    
    if (!response.ok) {
      throw new Error(`Failed to search item units by barcode in company: ${response.status}`);
    }
    
    return await response.json();
  }
}

export const itemUnitsService = new ItemUnitsService();
